<div class="container-fluid">
  <div class="page-head">
    <h5 class="header-title text-primary pl-2 pl-md-1">CONSULTATION ROOM</h5>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <p class="text-center font-size-15 font-weight-400">
                ENTER PATIENT NAME OR APPOINTMENT DATE
              </p>
            </div>
          </div>
          <br />
          <form [formGroup]="findAppointmentForm">
            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <input type="text" class="form-control select" placeholder="Patient Name" name="patName"
                  formControlName="patName" />
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div class="d-flex">
                  <input class="form-control" placeholder="Date of Appointment (DD/MM/YYYY)" name="appointmentDate"
                    ngbDatepicker #appointment="ngbDatepicker" data-date-inline-picker="false" id="appointmentDate"
                    formControlName="apDate" />
                  <div>
                    <button class="btn btn-outline-secondary button-height calendar rounded-0"
                      (click)="appointment.toggle()" type="button" id="AppointmentButton">
                      <span class="fa fa-calendar"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <br /><br />
            <div class="row">
              <div class="col-12 text-center">
                <button type="submit" name="find" class="btn btn-primary text-white" (click)="getAppointments()">
                  FIND APPOINTMENT
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid" *ngIf="appointments?.length || filterActive">
  <div class="row">
    <div class="col-md-12">
      <div class="card m-b-30">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <button type="submit" name="find"
                class="btn btn-rounded button-color text-white button-padding mr-4 mt-md-1 mt-2"
                [ngClass]="{ 'btn-primary': !activeBtn }" (click)="getAppointments()">
                ALL
              </button>
              <button type="submit" name="find"
                class="btn btn-rounded text-white btn-rounded button-color pl-4 pr-4 mr-4 mt-md-1 mt-2"
                [ngClass]="{ 'btn-primary': activeBtn === 'INPERSON' }" (click)="getAppointments('INPERSON', 1)">
                <img src="/assets/images/person.png" class="mr-2" />INPERSON
              </button>
              <button type="submit" name="find"
                class="btn btn-rounded text-white btn-rounded button-color pl-4 pr-4 mr-4 mt-md-1 mt-2"
                [ngClass]="{ 'btn-primary': activeBtn === 'ONLINE' }" (click)="getAppointments('ONLINE', 1)">
                <img src="/assets/images/computer.svg" class="mr-2" />ONLINE
              </button>
            </div>
          </div>

          <div class="row" *ngIf="appointments?.length">
            <div class="col-md-12 mt-3 detail-tbl">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col" class="w-17 text-center">TYPE</th>
                      <th scope="col" class="w-20">DATE</th>
                      <th scope="col" class="w-20">TIME</th>
                      <th scope="col" class="w-20">PATIENT NAME</th>
                      <th scope="col" class="w-20">CONSULTING DOCTOR</th>
                      <th scope="col" class="text-center">ACTION</th>
                    </tr>
                  </thead>
                  <tr *ngFor="let apt of appointments">
                    <td class="font-size-15">
                      <img src="/assets/images/profile-person.png" class="ml-3 ml-md-5 rectangle"
                        *ngIf="apt?.apttype == appointmentType.IN_PERSON && apt.online_checkin" />
                      <img src="/assets/images/profile-person.png" class="ml-3 ml-md-5"
                        *ngIf="apt?.apttype == appointmentType.IN_PERSON && !apt.online_checkin" />
                      <img src="/assets/images/computer-icon.svg" class="ml-3 ml-md-5"
                        *ngIf="apt?.apttype !== appointmentType.IN_PERSON" />
                    </td>
                    <td class="font-size-15 text-color">
                      {{ apt?.apdatetime | date: dateFormat }}
                    </td>
                    <td class="font-size-15 text-color">{{ apt?.aptime }}</td>
                    <td class="font-size-15 text-color">
                      {{ apt?.first_name }} {{ apt?.last_name }}
                    </td>
                    <td class="font-size-15 text-color">
                      {{ apt?.physician_first_name }}
                      {{ apt?.physician_last_name }}
                    </td>
                    <td>
                      <div class="col-12">
                        <div class="d-flex justify-content-center">
                          <!--<a href="{{apt?.conference_link}}" *ngIf="apt?.conference_link" target="_blank"><img
                              src="/assets/images/play.png" class="float-left pr-1 pb-1 pt-1 pl-0"></a>
                          <button type="button" class="btn btn-primary btn-sm border-radius pl-4 pr-4 float-right"
                            [ngClass]="{'ml-20': !apt?.conference_link}"
                            (click)="gotoPrescriptionPage(apt)">Consult</button>-->
                          <button type="button" class="btn btn-primary btn-sm border-radius pl-4 pr-4 float-right"
                            (click)="gotoPrescriptionPage(apt)">
                            Consult
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
                <!-- Pagination -->
                <div class="d-flex">
                  <div class="form-group d-flex mb-0 mr-2">
                    <select class="form-control" [(ngModel)]="pagesize" id="pagesize" (change)="pageChanged()">
                      <option *ngFor="let c of pageCount" value="{{ c }}">
                        {{ c }}
                      </option>
                    </select>
                  </div>
                  <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [maxSize]="5" [pageSize]="pagesize"
                    [rotate]="true" [boundaryLinks]="true" (pageChange)="pageChanged()">
                  </ngb-pagination>
                  <div class="ml-2 line-h-36">
                    Total rows : {{ collectionSize }}
                  </div>
                </div>
                <!-- ./ Pagination -->
              </div>
            </div>
          </div>

          <div class="row" *ngIf="!appointments?.length && filterActive">
            <div class="col-lg-12 mt-2 text-center">
              <h5 class="text-danger">NO APPOINTMENT FOUND</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid" *ngIf="noAppointments && !filterActive">
  <div class="card m-b-30">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h5 class="text-danger">NO APPOINTMENT FOUND</h5>
        </div>
      </div>
    </div>
  </div>
</div>